import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const toolbarStyles = makeStyles(({ palette }: Theme) => ({
  toolbar: {
    backgroundColor:
      palette.type === "light"
        ? palette.primary.main
        : palette.background.default,
    width: "100%",
    padding: 0,
    paddingTop: "1rem",
    display: "flex",
    flexDirection: "column",
  },
  gridContainer: { padding: "0 1rem", height: 80 },
  buttonReset: { padding: 0, minWidth: "auto", textTransform: "unset" },
  timeContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  timeButton: {
    display: "inline-block",
    padding: 0,
    minWidth: "auto",
  },
  meridiemContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  meridiemButton: { minWidth: 0, padding: 0, justifyContent: "start" },
  meridiemButtonSelected: { color: palette.primary.dark },
  tabControl: {
    flex: 1,
  },
}));
